import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ConstantsService {
	public backendUrl: string;
	public serverHttpOrHttps: string;
	public serverAddress: string;
	public serverArtifact: string;
	public serverPort: number;

	private userAuthority = new BehaviorSubject<number>(null);

	public beneficiaireUrl: string;
	public prescripteurUrl: string;
	public employeurUrl: string;
	public formationUrl: string;
	public employeeUrl: string;
	public buildSolutionUrl: string;
	public getSolutionUrl: string;
	public planningUrl: string;
	public prestationUrl: string;
	public qualificationUrl: string;
	public situationPrestationUrl: string;
	public suiviPrecoUrl: string;
	public evaluationUrl: string;
	public capaciteUrl: string;
	public miseEnOeuvreEmploiUrl: string;
	public infosasUrl: string;
	public routeUrl: string;
	public vacationTypeUrl: string;
	public evaluateUrl: string;

	public authUrl: string;
	public statisticsUrl: string;
	public activityReportEmployeeUrl: string;
	public activityReportBeneficiaireUrl: string;
	public funderReportUrl: string;

	public missionPlaceUrl: string;
	public specialiteUrl: string;
	public expertiseUrl: string;
	public typeHandicapUrl: string;
	public tauxReconnaissanceUrl: string;
	public niveauEtudeUrl: string;
	public niveauQualificationUrl: string;
	public typeStructureUrl: string;
	public typeEntrepriseUrl: string;
	public typeEntretienUrl: string;
	public typeDocumentUrl: string;
	public modaliteReunionUrl: string;
	public origineDemandeUrl: string;
	public objectifProUrl: string;
	public amenagementUrl: string;
	public situationFamilialeUrl: string;
	public statutProfessionnelUrl: string;
	public eligibiliteBeneficiaireUrl: string;
	public departementUrl: string;
	public regionUrl: string;
	public serviceUrl: string;
	public tacheUrl: string;
	public situationUrl: string;
	public notificationEmailUrl: string;
	public typeFormationUrl: string;
	public canalCommunicationUrl: string;
	public bonCommandeUrl: string;
	public bonCommandeReferenceUrl: string;

	public userUrl: string;
	public userBackUrl: string;
	public profileUrl: string;
	public permissionUrl: string;
	public missionUrl: string;

	public vehiculeUrl: string;
	public suiviPrestationUrl: string;
	public prestationFichierUrl: string;
	public activitePrestationUrl: string;
	public restitutionPrestationUrl: string;

	public paramPreferencesBeneficiaire: string;
	public paramVehicule: string;
	public messageUrl: string;
	public userConvUrl: string;
	public notificationsUrl: string;
	public messageNotificationUrl: string;

	public vacationUrl: string;

	public unavailabilityUrl: string;

	public centerUrl: string;
	public areaUrl: string;
	public missionTypeUrl: string;
	public funderUrl: string;

	public exportUrl: string;
	public availabilityUrl: string;
	public missionWithMultipleEmployeeUrl: string;
	public institutionUrl: string;

	public loginIsy: string;
	public passwordIsy: string;

	//OPTIM
	public optimUrl: string;
	constructor() {
		this.serverHttpOrHttps = environment.serverHttpOrHttps;
		this.serverAddress = environment.serverAddress;
		this.serverPort = environment.serverPort;
		this.serverArtifact = environment.serverArtifact;
		this.backendUrl =
			this.serverHttpOrHttps +
			'://' +
			this.serverAddress +
			':' +
			this.serverPort +
			'/'+
			this.serverArtifact +
			'/v1';

		// this.backendUrl =
		//  	this.serverHttpOrHttps +
		//  	'://' +
		//  	this.serverAddress +
		//  	':' +
		//  	this.serverPort +
		//  	'/v1';

		this.authUrl =
			this.serverHttpOrHttps +
			'://' +
			this.serverAddress +
			':' +
			this.serverPort+
			'/'+
			this.serverArtifact;

		// this.authUrl =
		//  	this.serverHttpOrHttps +
		//  	'://' +
		//  	this.serverAddress +
		//  	':' +
		//  	this.serverPort;

		this.loginIsy = 'assistante';
		this.passwordIsy = '1wXG9frX';

		this.updateAllUrls();
	}

	updateAllUrls() {
		this.beneficiaireUrl = `${this.backendUrl}/beneficiaire`;
		this.prescripteurUrl = `${this.backendUrl}/prescripteur`;
		this.employeurUrl = `${this.backendUrl}/employeur`;
		this.formationUrl = `${this.backendUrl}/formation`;
		this.employeeUrl = `${this.backendUrl}/intervenant`;
		this.buildSolutionUrl = `${this.backendUrl}/build`;
		this.getSolutionUrl = `${this.backendUrl}/solution`;
		this.routeUrl = `${this.backendUrl}/route`;
		this.planningUrl = `${this.backendUrl}/planning`;
		this.prestationUrl = `${this.backendUrl}/prestation`;
		this.qualificationUrl = `${this.backendUrl}/qualification`;
		this.infosasUrl = `${this.backendUrl}/infosas`;
		this.situationPrestationUrl = `${this.backendUrl}/situationPrestation`;
		this.suiviPrecoUrl = `${this.backendUrl}/suiviPreco`;
		this.evaluationUrl = `${this.backendUrl}/evaluation`;
		this.capaciteUrl = `${this.backendUrl}/capacite`;
		this.miseEnOeuvreEmploiUrl = `${this.backendUrl}/miseEnOeuvreEmploi`;
		this.evaluateUrl = `${this.backendUrl}/evaluate`;

		this.authUrl = `${this.authUrl}/auth`;
		this.statisticsUrl = `${this.backendUrl}/statistique`;
		this.activityReportEmployeeUrl = `${this.backendUrl}/activityreport/employee`;
		this.activityReportBeneficiaireUrl = `${this.backendUrl}/activityreport/beneficiaire`;
		this.funderReportUrl = `${this.backendUrl}/funder/report`;

		this.missionPlaceUrl = `${this.backendUrl}/ecole`;
		this.vacationTypeUrl = `${this.backendUrl}/vacation_type`;
		this.specialiteUrl = `${this.backendUrl}/specialite`;
		this.expertiseUrl = `${this.backendUrl}/expertise`;
		this.typeHandicapUrl = `${this.backendUrl}/typeHandicap`;
		this.tauxReconnaissanceUrl = `${this.backendUrl}/tauxReconnaissance`;
		this.niveauEtudeUrl = `${this.backendUrl}/niveauEtude`;
		this.niveauQualificationUrl = `${this.backendUrl}/niveauQualification`;
		this.typeStructureUrl = `${this.backendUrl}/typeStructure`;
		this.typeEntrepriseUrl = `${this.backendUrl}/typeEntreprise`;
		this.typeEntretienUrl = `${this.backendUrl}/typeEntretien`;
		this.typeDocumentUrl = `${this.backendUrl}/typeDocument`;
		this.modaliteReunionUrl = `${this.backendUrl}/modaliteReunion`;
		this.origineDemandeUrl = `${this.backendUrl}/origineDemande`;
		this.objectifProUrl = `${this.backendUrl}/objectifPro`;
		this.amenagementUrl = `${this.backendUrl}/amenagement`;
		this.situationFamilialeUrl = `${this.backendUrl}/situationFamiliale`;
		this.statutProfessionnelUrl = `${this.backendUrl}/statutProfessionnel`;
		this.eligibiliteBeneficiaireUrl = `${this.backendUrl}/eligibiliteBeneficiaire`;
		this.canalCommunicationUrl = `${this.backendUrl}/canalCommunication`;
		this.departementUrl = `${this.backendUrl}/departement`;
		this.regionUrl = `${this.backendUrl}/region`;
		this.serviceUrl = `${this.backendUrl}/service`;
		this.tacheUrl = `${this.backendUrl}/tache`;
		this.situationUrl = `${this.backendUrl}/situation`;
		this.notificationEmailUrl = `${this.backendUrl}/notificationEmail`;
		this.typeFormationUrl = `${this.backendUrl}/typeFormation`;
		this.userUrl = `${this.backendUrl}/users`;
		this.userBackUrl = `${this.backendUrl}/userBack`;
		this.bonCommandeUrl = `${this.backendUrl}/bonCommande`;
		this.bonCommandeReferenceUrl = `${this.backendUrl}/bonCommandeReference`;

		this.userConvUrl = `${this.backendUrl}/messages/conversations`;

		this.profileUrl = `${this.backendUrl}/profiles`;
		this.permissionUrl = `${this.backendUrl}/permissions`;
		this.missionUrl = `${this.backendUrl}/mission`;
		this.vehiculeUrl = `${this.backendUrl}/vehicle`;
		this.paramPreferencesBeneficiaire = `${this.backendUrl}/parametre/preferences/beneficiaire`;
		this.paramVehicule = `${this.backendUrl}/parametre/vehicule`;
		this.messageUrl = `${this.backendUrl}/messages`;
		this.notificationsUrl = `${this.backendUrl}/notifications`;
		this.messageNotificationUrl = `${this.backendUrl}/messagerie/notifications`;
		this.vacationUrl = `${this.backendUrl}/vacation`;
		this.unavailabilityUrl = `${this.backendUrl}/unavailability`;
		this.centerUrl = `${this.backendUrl}/center`;
		this.areaUrl = `${this.backendUrl}/area`;
		this.missionTypeUrl = `${this.backendUrl}/mission/type`;
		this.funderUrl = `${this.backendUrl}/funder`;

		this.optimUrl = `${this.backendUrl}/optim`;
		this.exportUrl = `${this.backendUrl}/export`;
		this.availabilityUrl = `${this.backendUrl}/availability`;
		this.missionWithMultipleEmployeeUrl = `${this.backendUrl}/event/group`;
		this.suiviPrestationUrl = `${this.backendUrl}/suiviPrestation`;
		this.prestationFichierUrl = `${this.backendUrl}/prestationFichier`;
		this.activitePrestationUrl = `${this.backendUrl}/activitePrestation`;
		this.restitutionPrestationUrl = `${this.backendUrl}/restitutionPrestation`;
		this.institutionUrl = `${this.backendUrl}/institution`;
	}

	updateUserAuthority(authority: number) {
		this.userAuthority.next(authority);
	}

	public getUserAuthorityObservable(): Observable<number> {
		return this.userAuthority.asObservable();
	}
}

export const BASE_NOMINATIM_URL = 'nominatim.openstreetmap.org';
export const DEFAULT_VIEW_BOX =
	'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000';
export const API_ADRESSE_DATA_GOUV = 'api-adresse.data.gouv.fr';
export const GEO_API_GOUV = 'geo.api.gouv.fr';

// CENTER PARAMETERS
export const PARAM_PREFERENCES_BENEFICIAIRE = 'preferences_beneficiaire';
export const PARAM_VEHICULE = 'vehicule_mode';

export const PARAM_VEHICULE_VALUE_OFF = 'OFF';

export const PARAM_HOMECARE = 'home_care';
export const PARAM_IS_AVAILABILITY_PLANNING_VISIBLE =
	'availability_planning_visible';

export const PARAM_OPTIM_PARAMS_EDITABLE = 'optim_params_editable';

export const PARAM_LABEL_INTERVENANT = 'label_intervenant';
export const PARAM_LABEL_BENEFICIAIRE = 'label_beneficiaire';
export const PARAM_LABEL_INTERVENTION = 'label_intervention';
export const PARAM_LABEL_USER = 'label_user';

export const PARAM_LABEL_HOUR_MIN_DAY = 'hour_min_day'; // hours
export const PARAM_LABEL_HOUR_MAX_DAY = 'hour_max_day'; // hours
export const FORMATION_DURATION_MAX = 900; // 900 minutes = 15H

export const MISSION_TYPE_REUNION_TYPE = 'Réunion';

export const OPTIM_QUEUE = 'optim_queue';

export const AREA_ACTIVE = 'area_active';
export const OPTIM_MULTIPLE = 'optim_multiple';

export const THEME_COLOR_MAIN = '#262c5e';
export const THEME_COLOR_BLUE = '#668bc7';
export const THEME_COLOR_RED = '#ed7387';
export const THEME_COLOR_GREEN = '#8dcdcb';
export const THEME_COLOR_PINK = '#f19eaf';
export const THEME_COLOR_VIOLET = '#a3acd8';

export const PARAM_MAX_ANNULATION_TARDIVE_IN_HOURS =
	'max_annulation_tardive_in_hours';

export const PARAM_FUNDER_ACTIVE = 'funder_active';

export const CACHE_LIFETIME = 3; // minutes
